import { IStudioLibraryItem } from "@app/shared/models/IStudioLibraryItem";
import { AssetType } from "@app/shared/models/assetType";

export class PageTemplate implements IStudioLibraryItem{
  id: number;
  uuid:string;
  name: string;
  type:AssetType;
  src: string;
  fabricElem:any;
  targetField:string;
  svgSrc:string;
  jsonSrc:string;
  payload:string;
  rJson:string;
  specialType:string;
  compGeneric:string;
  dateCreated:number;
  dateLastModified:number;
  isPrincipal:string;
  numslots:number;
  grid:any;
  displayed:boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/pageTemplate.ts